enum DefaultApiLimit {
  limit = 20,
  page = 1,
}

// Change default export when adding more enum
export default DefaultApiLimit;
